<template>
    <div class="footer">
        <b-container>
            <b-row class="mb-3">
                <b-col md="6">
                    <h2>Contáctanos</h2>
                    <p class="subtext">Envíanos un mensaje o llámanos para cualquier duda que tengas. </p>
                    
                    <p class="footer-info"> <img src="../assets/footer/telefono.png" alt="icon phone"> 686 564 9090</p>
                    <p class="footer-info"> <img src="../assets/footer/ubi.png" alt="icon ubication"> Calle Profesor Charles Piña #657 <br>
                    Col.Rivera, Mexicali, BC, CP 21259</p>
                    <p class="footer-info"> <img src="../assets/footer/correo.png" alt="icon ubication"> RH<br>
                        <a href="mailto:jesus.ramos@ctrendy.mx">jesus.ramos@ctrendy.mx</a><br>
                    <p class="footer-info">VENTAS<br>
                        <a href="mailto:cesar.montiel@ctrendy.mx">cesar.montiel@ctrendy.mx</a><br>
                        <a href="mailto:elsa.rodriguez@ctrendy.mx">elsa.rodriguez@ctrendy.mx</a></p>
                </b-col>
                <b-col md="6">
                    <p class="sendText">{{ messageSend }}</p>
                    <div class="mb-3 form-floating">
                        <b-form-input id="input-1" v-model="name" placeholder="Name*" type="text"></b-form-input>
                        <label for="input-1">Nombre y Apellido</label>
                    </div>
                    <div class="mb-3 form-floating">
                        <b-form-input id="input-3" v-model="phone" placeholder="Phone*" type="text"></b-form-input>
                        <label for="input-3">Teléfono</label>
                    </div>
                    <div class="mb-3 form-floating">
                        <b-form-input id="input-2" v-model="email" placeholder="Email*" type="text"></b-form-input>
                        <label for="input-2">Correo electrónico</label>
                    </div>
                    <div class="mb-3"> 
                        <b-form-textarea class="textfooter" id="input-3" v-model="message" placeholder="Mensaje" rows="5" max-rows="3"></b-form-textarea>
                    </div>
                    <b-form-input autocomplete="off" tabindex="-1" id="input-1" class="pet-field" v-model="pet" placeholder="Alimento de mascota" type="text"></b-form-input>
                    <b-button class="btn btn-enviar" v-on:click="sendMessage">Enviar mensaje</b-button>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="12">
                    <a href="#" class="privacylink">Aviso de privacidad</a>
                </b-col>
            </b-row>
        </b-container>
        <img class="img-circle" src="../assets/footer/circles2.svg" alt="">
    </div>
</template>

<script>
import axios from 'axios'

    export default {
        name: 'footer',
        data() {
            return {
                name: '',
                email: '',
                phone: '',
                message: '',
                pet:'',
                messageSend: ''
            }
        },
        methods: {
            sendMessage: async function(){
                var responseData
                if(this.name != '' && this.email != '' && this.pet == ''){
                    await axios.post('vendor/send-contact.php', {
                        name: this.name,
                        email: this.email,
                        phone: this.phone,
                        message: this.message
                    })
                    .then((response) => {
                        responseData = response.data
                    })
                    .catch((error) => {
                        /* eslint-disable no-console */
                        console.log(error);
                        /* eslint-enable no-console */
                    });
                    console.log(responseData);
                    if(responseData==200 || responseData=='200') {
                        this.name = ''
                        this.email = ''
                        this.phone = ''
                        this.message = ''
                        this.messageSend = 'Mensaje enviado.'
                    } else {
                        this.messageSend = 'Error al enviar mensaje, intenta mas tarde.'
                    }
                } else {
                    this.messageSend = 'Ingresa la información necesaria en los campos.'
                }
            }
        }
    }
</script>

<style scoped>
.footer{
    background: #001824; 
    padding: 130px 10% 100px;
    color: #fff;
    position: relative;
}
.img-circle{
    position: absolute;
    bottom: 0;
    left: 0;
    opacity: 0.3;
}
.container{
    max-width: 1043px;
    margin-left: auto;
    margin-right: auto; 
}

h2{
    color: #9DF002;
    font-weight: 700;
    font-size: 50px;
}

p{
    font-size: 20px;
    line-height: 25px;
}

.subtext{
    color: #FFF;
    margin-bottom: 40px;
}

.footer-info{
    padding-left: 25px;
    position: relative;
}

.footer-info img{
    position: absolute;
    top: 5px;
    margin-left: -25px;
}

.footer-info a{
    color: #fff;
    text-decoration: none;
}

/* FORM */
.btn-enviar{
    width: 100%; 
    color: #fff !important;
    font-size: 22px;
    background: #FC5300 !important;
    border: none;
    padding: 10px;
}

.form-floating > .form-control{
    background: transparent;
    border: #fff solid 1px;
    border-radius: 5px;
    color: #fff;
    font-size: 20px;
    outline: none !important;
}

.form-floating > .form-control:focus ~ label, .form-floating > .form-control:not(:placeholder-shown) ~ label, .form-floating > .form-control-plaintext ~ label, .form-floating > .form-select ~ label {
    color: rgba(255,255,255, 0.4) !important; 
    -webkit-transform: scale(0.65) translateY(-0.5rem) translateX(0rem);
    transform: scale(0.65) translateY(-0.5rem) translateX(0rem);
}

label{
    color: #fff;
    font-size: 20px;
}
textarea{
    background: transparent;
    border-radius: 5px;
    border: 1px solid #fff;
    outline: none;
    font-size: 20px;
    color: #fff !important;
}
textarea:focus,
textarea:active,
input:focus,
input:active{
    background: transparent;
    outline: none !important;
    box-shadow: none !important;
}
.form-floating label{
    font-size: 20px;
    color: #fff !important;
}
.form-floating > .form-control:focus ~ label::after, .form-floating > .form-control:not(:placeholder-shown) ~ label::after, .form-floating > .form-control-plaintext ~ label::after, .form-floating > .form-select ~ label::after{
    background: transparent;
    color: #fff !important;
}
.pet-field{
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    height: 0;
    width: 0;
    z-index: -1;
}

.sendText{
    font-size: 16px;
    font-weight: 700;
}

.privacylink{
    text-decoration: none;
    color: rgba(255,255,255,0.4);
    margin-top: 20px;
}

.footer textarea:-moz-placeholder, /* Firefox 18- */
.footer textarea::-moz-placeholder, /* Firefox 19+ */
.footer textarea:-ms-input-placeholder, /* IE 10+ */
.footer textarea::-webkit-input-placeholder, /* Webkit based */
.textfooter::placeholder{
  color: #fff !important;
  opacity: 1;
}

@media (max-width: 768px){
    .footer{
        padding: 80px 7% 50px;
    }

    h2{
        font-size: 40px;
    }

    p{
        font-size: 18px;
        line-height: 22px;
    }

    .subtext{
        color: #B7EFFF;
        margin-bottom: 40px;
    }

    .footer-info{
        padding-left: 25px;
        position: relative;
    }

    .footer-info img{
        position: absolute;
        top: 5px;
        margin-left: -25px;
    }
}
</style>